export const resetHierarchy = (nodes) => {
  if (!Array.isArray(nodes)) {
    return nodes;
  }

  return nodes.map((node) => ({
    ...node,
    isChecked: false,
    isExpanded: false,
    children: Array.isArray(node.children)
      ? resetHierarchy(node.children)
      : node.children,
  }));
};